module.exports = __webpack_public_path__ + "img/insta-7.e450bd10.jpg";